import React, { FC, ReactNode } from 'react';

export interface RSBorderedListProps {
  children?: ReactNode;
}

export const RSBorderedList: FC<RSBorderedListProps> = ({ children }) => {
  return (
    <ul className="rounded-10 m-0 border border-solid border-gray-200 bg-white p-0">
      {children}
    </ul>
  );
};
